export const AVAILABLE_REDIRECTS = {
    COLLEGE_PROFILE: 'college-profile',
};
export const PUBLIC_SIGNED_IN_APP_CONFIG = {
    app: 'student',
    lastSignedIn: '1',
    supportedRedirects: {
        [AVAILABLE_REDIRECTS.COLLEGE_PROFILE]: true,
    },
};
